"use client";

import type { PageCheckoutResult } from "@/lib/api/payment-page.schema";
import type { Dictionary } from "@/app/[lang]/dictionaries";
import { Text } from "@/components/ui/text";
import { Button } from "@/components/ui/button";
import { CheckCircle2Icon } from "lucide-react";
import { formatAmount } from "@/app/[lang]/checkout/[token]/_components/payment.utils";

interface PageSuccessViewProps {
  result: PageCheckoutResult;
  merchantName: string;
  dictionary: Dictionary;
  onContinue: () => void;
}

export function PageSuccessView({
  result,
  merchantName,
  dictionary,
  onContinue,
}: PageSuccessViewProps) {
  const { paymentPage } = dictionary;

  return (
    <div className="h-full rounded-lg border border-border p-6">
      <div className="flex flex-col items-center justify-center space-y-6 py-6">
        <div className="flex size-16 items-center justify-center rounded-full bg-primary/10">
          <CheckCircle2Icon className="size-8 text-primary" />
        </div>
        <div className="text-center">
          <Text variant="h3" className="mb-2">
            {paymentPage.paymentSuccess}
          </Text>
          <Text variant="muted">
            {formatAmount(
              result.charged_amount ?? result.amount,
              result.charged_currency ?? result.currency,
            )}{" "}
            {paymentPage.paidTo}{" "}
            {merchantName}
          </Text>
        </div>
        <Button onClick={onContinue}>{paymentPage.continue}</Button>
      </div>
    </div>
  );
}
